import { type RootState } from '../../../lib/store';
import { DATA_IMPORT_MODES } from '../constants';

// Stable empty array reference to avoid unnecessary re-renders

export const selectActiveStep = (state: RootState) => state.createProject?.activeStep ?? 0;

export const selectConditionArea = (state: RootState) => state.createProject?.conditionArea ?? null;
export const selectHealthSystem = (state: RootState) => state.createProject?.healthSystem ?? null;
export const selectProjectName = (state: RootState) => state.createProject?.projectName ?? '';
export const selectAddedConcepts = (state: RootState) => state.createProject?.addedConcepts ?? [];
export const selectWorkflowId = (state: RootState) => state.createProject?.workflowId ?? null;
export const selectSelectedAnnotators = (state: RootState) =>
  state.createProject?.selectedAnnotators ?? [];
export const selectSelectedSupervisors = (state: RootState) =>
  state.createProject?.selectedSupervisors ?? [];
export const selectDefaultAllocationMode = (state: RootState) =>
  state.createProject?.defaultAllocationMode ?? true;
export const selectUploadedNotesParquetFileName = (state: RootState) =>
  state.createProject?.uploadedNotesParquetFileName ?? null;
export const selectUploadedPersonParquetFileName = (state: RootState) =>
  state.createProject?.uploadedPersonParquetFileName ?? null;
export const selectUploadedVisitParquetFileName = (state: RootState) =>
  state.createProject?.uploadedVisitParquetFileName ?? null;
export const selectNotesS3FilePath = (state: RootState) =>
  state.createProject?.notesS3FilePath ?? null;
export const selectPersonS3FilePath = (state: RootState) =>
  state.createProject?.personS3FilePath ?? null;
export const selectVisitS3FilePath = (state: RootState) =>
  state.createProject?.visitS3FilePath ?? null;
export const selectUploadedDatasplittingJSONFileName = (state: RootState) =>
  state.createProject?.uploadedDatasplittingJSONFileName ?? null;
export const selectDatasplitJsonS3FilePath = (state: RootState) =>
  state.createProject?.datasplitJsonS3FilePath ?? null;
export const selectDatasetImportMode = (state: RootState) =>
  state.createProject?.datasetImportMode ?? DATA_IMPORT_MODES[0];
export const selectDatasplitImportMode = (state: RootState) =>
  state.createProject?.datasplitImportMode ?? DATA_IMPORT_MODES[0];
